import React from "react";
import AddComponent from "../Base/AddComponent";
import { getLoggedUser } from "../../context/auth";

let loggedUser = {};
const GlobalConfig = new window.globalConfig();

class App extends AddComponent {
  constructor(props) {
    super();
    loggedUser = getLoggedUser();

    this.state = {
      title: "Classification Item",
      listtitle: "Classification Items",
      urllist:
        process.env.REACT_APP_URL_CLASSIFICATION_LIST +
        "/classification-items/" +
        props.match.params.id,
      urlapi: GlobalConfig.REACT_APP_API_CLASSIFICATION_ITEM_URL,
      alertshow: false,
      alerttype: "",
      alertmsg: "",
      parentId: props.match.params.id,
      data: {
        parentId: props.match.params.id,
        // processorID pass to backend for create log audit
        processorId: loggedUser.processorId,
        name: "",
        createdUserId: loggedUser._id,
      },
    };
  }

  handResetForm = () => {
    this.setState({
      data: {
        parentId: this.state.parentId,
        // processorID pass to backend for create log audit
        processorId: loggedUser.processorId,
        name: "",
        createdUserId: loggedUser._id,
      },
    });
  };

  renderForm = () => {
    return (
      <div className="panel-body">
        <div className="form-group">
          <label className="col-sm-3 control-label">
            Name <span className="required">*</span>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="name"
              autoFocus={true}
              className="form-control"
              placeholder=""
              required
              value={this.state.data.name}
              onChange={this.handleChange}
              maxLength={100}
            />
          </div>
        </div>
      </div>
    );
  };

  extendBreadcrumb = () => {
    return (
      <li>
        <a
          href={process.env.REACT_APP_URL_CLASSIFICATION_LIST}
          title="Back to list"
        >
          Classifications
        </a>
      </li>
    );
  };

  extendButtons = () => {
    return (
      <a href={this.state.urladd} className="btn btn-primary">
        <i className="fa fa-plus"></i> Add
      </a>
    );
  };
}
export default App;
